import React from 'react'
import { HiOutlineSearch } from "react-icons/hi"
import { FaPlus } from "react-icons/fa"
import { ImAttachment } from "react-icons/im"
import { MdOutlineWatchLater } from "react-icons/md"
import man from "../../images/man.png";

const TaskManagement = () => {

  return (
    <>
      <div className='task_main_div'>
        <div className='task_hed'><h1>Task Management</h1></div>
        <div className='Task_hed2'>
          <div className='Task_sidebar'>
            <ul class="sidebar">
              <li>Eclcus</li>
              <li>eclcus</li>
              <li>Candidate</li>
              <li>Project3</li>
              <li>Eclcus</li>
            </ul>
          </div>
          <div className='prod_task'>
            <div className='Task_list'>
              <div className='Task_search'>
                <div class="wrap">
                  <div class="search">
                    <input type="text" class="searchTerm" placeholder="Search" />
                    <button type="submit" class="searchButton">
                      <HiOutlineSearch />
                    </button>
                  </div>
                </div>
              </div>
              <div className='Task_name'>
                <p>Akshay Kumar</p>
                <p><img src={man} alt="man" /></p>
              </div>
            </div>
            <div className='new_div'>
              <div><h3>Eclcus</h3></div>
              <div className='week'>This Week</div>
            </div>
            <div className='Task_Card'>
              <div class="cards-list">
                <div class="card 1">
                  <div className='card11'>
                    <div class=""><p>Pending Task</p></div>
                    <div class=""><p>3 </p></div>
                  </div>
                  <div className='btn_plus'>
                    <button type="button" ><FaPlus /></button>
                  </div>
                  <div className='des_div'>
                    <div className="Design">
                      <p>Implement Design</p>
                      <p><ImAttachment /></p>
                    </div>
                    <div className='para_div'>
                      <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.</p>
                    </div>
                    <div className="Design">
                      <p style={{ paddingTop: "15px", fontSize: "20px" }}><MdOutlineWatchLater /> 3 PM</p>
                      <p className='man_img'><img src={man} alt="man" /></p>
                    </div>
                  </div>
                  <div className='des_div'>
                    <div className="Design">
                      <p>Implement Design</p>
                      <p><ImAttachment /></p>
                    </div>
                    <div className='para_div'>
                      <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.</p>
                    </div>
                    <div className="Design">
                      <p style={{ paddingTop: "15px", fontSize: "20px" }}><MdOutlineWatchLater /> 3 PM</p>
                      <p className='man_img'><img src={man} alt="man" /></p>
                    </div>
                  </div>
                  <div className='des_div'>
                    <div className="Design">
                      <p>Implement Design</p>
                      <p><ImAttachment /></p>
                    </div>
                    <div className='para_div'>
                      <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.</p>
                    </div>
                    <div className="Design">
                      <p style={{ paddingTop: "15px", fontSize: "20px" }}><MdOutlineWatchLater /> 3 PM</p>
                      <p className='man_img'><img src={man} alt="man" /></p>
                    </div>
                  </div>
                </div>
                <div class="card 1">
                  <div className='card11'>
                    <div className=""><p>In Progress</p></div>
                    <div className=""><p>2</p></div>
                  </div>
                  <div className='btn_plus'>
                    <button type="button" ><FaPlus /></button>
                  </div>
                  <div className='des_div'>
                    <div className="Design">
                      <p>Implement Design</p>
                      <p><ImAttachment /></p>
                    </div>
                    <div className='para_div'>
                      <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.</p>
                    </div>
                    <div className="Design">
                      <p style={{ paddingTop: "15px", fontSize: "20px" }}><MdOutlineWatchLater /> 3 PM</p>
                      <p className='man_img'><img src={man} alt="man" /></p>
                    </div>
                  </div>
                  <div className='des_div'>
                    <div className="Design">
                      <p>Implement Design</p>
                      <p><ImAttachment /></p>
                    </div>
                    <div className='para_div'>
                      <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.</p>
                    </div>
                    <div className="Design">
                      <p style={{ paddingTop: "15px", fontSize: "20px" }}><MdOutlineWatchLater /> 3 PM</p>
                      <p className='man_img'><img src={man} alt="man" /></p>
                    </div>
                  </div>
                </div>
                <div class="card 1">
                  <div className='card11'>
                    <div class=""><p>Completed</p></div>
                    <div class=""><p>1</p></div>
                  </div>
                  <div className='btn_plus'>
                    <button type="button" ><FaPlus /></button>
                  </div>
                  <div className='des_div'>
                    <div className="Design">
                      <p>Implement Design</p>
                      <p><ImAttachment /></p>
                    </div>
                    <div className='para_div'>
                      <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.</p>
                    </div>
                    <div className="Design">
                      <p style={{ paddingTop: "15px", fontSize: "20px" }}><MdOutlineWatchLater /> 3 PM</p>
                      <p className='man_img'><img src={man} alt="man" /></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TaskManagement